import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconAnalysisValidation from '@/icons/AnalysisValidation.svg';

export const ArticleRequalificationValidatedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_requalification_validated'>;
  displayArticleName: boolean;
}) => {
  const creatorName = activity.creator.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconAnalysisValidation />}
      message={
        <>
          <BaseActivityText>
            <Trans id="activities.article_requalification_validated.message">
              <strong>{creatorName}</strong> validated the quote for the item{' '}
              <BaseActivityArticleName
                activity={activity}
                displayArticleName={displayArticleName}
              />
            </Trans>
          </BaseActivityText>
        </>
      }
    />
  );
};
